import { lazy, memo, Suspense } from 'react';
import { ClientOnly } from 'remix-utils/client-only';
import type { IconComponentProps } from '../typings';

export function createAsyncIcon(
  LazyComponentFn: () => Promise<{
    default: (props: IconComponentProps) => JSX.Element;
  }>,
) {
  const La = lazy(LazyComponentFn);
  return memo(function (props: IconComponentProps) {
    return (
      <ClientOnly fallback={<></>}>
        {() => {
          return (
            <Suspense fallback={<></>}>
              <La {...props} />
            </Suspense>
          );
        }}
      </ClientOnly>
    );
  });
}
